<div
  class="slider"
  [class.pointer-focus]="pointerFocus"
  tabindex="0"
  role="slider"
  aria-valuemin="0"
  [attr.aria-valuemax]="secondsMax"
  [attr.aria-valuenow]="secondsNow"
  [attr.aria-valuetext]="(secondsNow | duration | humanDuration:'long':'long') + ' ' + intl.seekSliderTimeCombinator + ' ' + (secondsMax | duration | humanDuration:'long':'long')"
  (pointerdown)="onPointerDown()"
  (click)="onClick($event)"
  (keydown)="onKeyDown($event)"
>
  <div class="track-full" #trackFull>

  </div>
  <div class="track-progress" #trackProgress>
    <div class="thumb" #thumb>
      <div class="thumb-display"></div>
    </div>
  </div>
</div>
